import { TARGET } from "../../constants/target.qwik.mjs";
import { isBrowser } from "../../functions/is-browser.qwik.mjs";
import { isEditing } from "../../functions/is-editing.qwik.mjs";
import { FILTER_WITH_CUSTOM_TARGETING_SCRIPT, PERSONALIZATION_SCRIPT, UPDATE_VISIBILITY_STYLES_SCRIPT } from "./helpers/inlined-fns.qwik.mjs";
import { filterWithCustomTargeting } from "./helpers/inlined-fns.qwik.mjs";
const DEFAULT_INDEX = "default";
const FILTER_WITH_CUSTOM_TARGETING_SCRIPT_FN_NAME = "filterWithCustomTargeting";
const BUILDER_IO_PERSONALIZATION_SCRIPT_FN_NAME = "builderIoPersonalization";
const UPDATE_VARIANT_VISIBILITY_SCRIPT_FN_NAME = "updateVisibilityStylesScript";
const SDKS_SUPPORTING_PERSONALIZATION = [
  "react",
  "vue",
  "svelte",
  "qwik"
];
const SDKS_REQUIRING_RESET_APPROACH = [
  "vue",
  "svelte",
  "qwik"
];
function checkShouldRenderVariants(variants, canTrack) {
  const hasVariants = variants && variants.length > 0;
  if (!hasVariants)
    return false;
  if (!canTrack)
    return false;
  if (SDKS_REQUIRING_RESET_APPROACH.includes(TARGET))
    return true;
  if (isBrowser())
    return false;
  return true;
}
function getBlocksToRender({ variants, previewingIndex, isHydrated, filteredVariants, fallbackBlocks }) {
  const fallback = {
    blocks: fallbackBlocks ?? [],
    path: "this.children",
    index: DEFAULT_INDEX
  };
  if (isHydrated && isEditing()) {
    if (typeof previewingIndex === "number" && previewingIndex < ((variants == null ? void 0 : variants.length) ?? 0)) {
      const variant = variants == null ? void 0 : variants[previewingIndex];
      if (variant)
        return {
          blocks: variant.blocks,
          path: `variants.${previewingIndex}.blocks`,
          index: previewingIndex
        };
    }
    return fallback;
  }
  if (isBrowser()) {
    const winningVariant = filteredVariants == null ? void 0 : filteredVariants[0];
    if (winningVariant && variants) {
      const variantIndex = variants.indexOf(winningVariant);
      if (variantIndex !== -1)
        return {
          blocks: winningVariant.blocks,
          path: `variants.${variantIndex}.blocks`,
          index: variantIndex
        };
    }
  }
  return fallback;
}
const getInitPersonalizationVariantsFnsScriptString = () => {
  return `
  window.${FILTER_WITH_CUSTOM_TARGETING_SCRIPT_FN_NAME} = ${FILTER_WITH_CUSTOM_TARGETING_SCRIPT}
  window.${BUILDER_IO_PERSONALIZATION_SCRIPT_FN_NAME} = ${PERSONALIZATION_SCRIPT}
  window.${UPDATE_VARIANT_VISIBILITY_SCRIPT_FN_NAME} = ${UPDATE_VISIBILITY_STYLES_SCRIPT}
  `;
};
const isHydrationTarget = TARGET === "react";
const getPersonalizationScript = (variants, blockId, locale) => {
  return `window.${BUILDER_IO_PERSONALIZATION_SCRIPT_FN_NAME}(${JSON.stringify(variants)}, "${blockId}", ${isHydrationTarget}${locale ? `, "${locale}"` : ""})`;
};
const getUpdateVisibilityStylesScript = (variants, blockId, locale) => {
  return `window.${UPDATE_VARIANT_VISIBILITY_SCRIPT_FN_NAME}(${JSON.stringify(variants)}, "${blockId}", ${isHydrationTarget}${locale ? `, "${locale}"` : ""})`;
};
export {
  DEFAULT_INDEX,
  SDKS_REQUIRING_RESET_APPROACH,
  SDKS_SUPPORTING_PERSONALIZATION,
  checkShouldRenderVariants,
  filterWithCustomTargeting,
  getBlocksToRender,
  getInitPersonalizationVariantsFnsScriptString,
  getPersonalizationScript,
  getUpdateVisibilityStylesScript
};
